import { METER_SERVICE_NAME, MeterServiceProvider } from './meter.service'
import { METER_CONTEXT_MENU_SERVICE_NAME, MeterContextMenuServiceProvider } from './meter.context-menu.service'

export const METER_SERVICES_MODULE_NAME = 'simax.services.meter'

const module = angular.module(METER_SERVICES_MODULE_NAME, [])

module.provider(METER_SERVICE_NAME, MeterServiceProvider)
module.provider(METER_CONTEXT_MENU_SERVICE_NAME, MeterContextMenuServiceProvider)
